'use client';

import { FunctionComponent, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { Modal } from '@/react/components/core-ui/Modal';
import { ModalHeader } from '@/react/components/core-ui/Modal/ModalHeader';

import { useBrandLocaleValue } from '@/react/hooks/useBrandLocaleValue';
import S from './styles.base.module.scss';

/**
 * The props for the ModalLink component.
 */
export interface IModalLinkModalProps {
  /**
   * The title of the modal.
   */
  modalTitle?: string;

  /**
   * Is the modal open.
   */
  isOpen?: boolean;

  /** The children of the `ModalLink` component. */
  children?: ReactNode;

  /**
   * Handles the closing of the modal.
   */
  handleModalClose: () => void;
}

/**
 * All this does is apply custom styling to the component within it.
 */
export const ModalLinkModal: FunctionComponent<IModalLinkModalProps> = ({
  modalTitle = '',
  isOpen = false,
  children,
  handleModalClose
}) => {
  const floatingClose = useBrandLocaleValue<boolean>(
    () => ({ default: false }),
    []
  );
  return (
    <>
      {createPortal(
        <div>
          <Modal className={S.modal} isOpen={isOpen} onClose={handleModalClose}>
            <ModalHeader
              floatingClose={floatingClose}
              className={S.modalHeader}
              onClose={handleModalClose}
            >
              {modalTitle}
            </ModalHeader>
            <div className={S.modalBody}>{children}</div>
          </Modal>
        </div>,
        document.body
      )}
    </>
  );
};

export default ModalLinkModal;
